import React, { useEffect } from 'react'
import { Grid } from "@mui/material"

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { BACKEND_APIS } from "@constants"
import { offices, reports } from "@signals"
import { setLastOfficeSubmitted } from "Pages/ReportsAlerts/Alerts/Notifications/@signals"
import { alertsSection, isPriceChangeTabLoading, isPriceChangeTabEmpty } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { conditionNameColumn, priceChangeDiffColumn, priceColumn } from "Pages/ReportsAlerts/Alerts/Notifications/PriceChange/columns"
import { comparatorColumn, lorColumn, pickupDateColumn, siteColumn } from "Pages/ReportsAlerts/Alerts/Notifications/@components"
import { batch } from "@preact/signals-react"
import { isTourDemoActive } from "@signals/app"
import { dsColorNew } from "@palette"


export default function PriceChangeBlock() {

	const { getTableData, tableData, isTableLoading, filterConditions } = useAlertsTableData(`${BACKEND_APIS.NOTIFICATIONS}/price-change`)

	useEffect(() => {
		if (!!offices.value && !!reports.value) {
			isPriceChangeTabLoading.value = true
			isPriceChangeTabEmpty.value = false
			getTableData({ idReportExecution: reports.value, idOfficePickup: offices.value })
				.then(data => { isPriceChangeTabEmpty.value = !data?.length })
				.finally(() => batch(() => {
					isPriceChangeTabLoading.value = false
					setLastOfficeSubmitted()
				}))
		}
	}, [reports.value, offices.value])

	if (alertsSection.value !== ALERTS.PRICE_CHANGE) return <></>
	if (isTourDemoActive.value && !tableData?.length) return <></>

	return <Grid item xs={12}>
		<AlertsBaseTable
			title="Notifications: Price Change"
			data={tableData}
			isLoading={isTableLoading}
			filterConditions={filterConditions}
			columns={[
				conditionNameColumn(),
				pickupDateColumn(),
				lorColumn(),
				...comparatorColumn("category", "Category"),
				...comparatorColumn("acriss", "Acriss"),
				...comparatorColumn("fuelPolicy", "Fuel Policy"),
				...comparatorColumn("transmission", "Transmission"),
				...comparatorColumn("mileage", "Mileage"),
				...comparatorColumn("terminal", "Vendor Airport Location"),
				...comparatorColumn("carDescription", "Car Description"),
				...siteColumn(),
				...comparatorColumn("provider", "Provider"),
				priceColumn(),
				...comparatorColumn("currency", "Currency", true),
				priceChangeDiffColumn(),
			]}
			legend={[
				{ icon: "percent", value: "%", label: "Percentage" },
				{ icon: "money-bills", value: "$", label: "Currency", iconProps: { color: dsColorNew.successText } },
				{ icon: "arrow-up", value: "Increase", label: "Price Increase", iconProps: { color: dsColorNew.successText } },
				{ icon: "arrow-down", value: "Decrease", label: "Price Decrease", iconProps: { color: dsColorNew.dangerRed } },
				{ icon: "arrow-down-arrow-up", value: "Increase/Decrease", label: "Price Difference", iconProps: { color: dsColorNew.noteAmber } },
			]}
		/>
	</Grid>
}